export const pokemon = {
  pokemon_page_title: 'List Pokemon',
  list_pokemon_button: 'Go to list pokemons',
  no_pokemon_found_message: 'No pokemons found!',
  height: 'height',
  base_experience: 'base experience',
  no_data_found_message: 'No data found!',
};
